const MEDIA_BASE_URL =
  "https://rullier-preprod.ova-consulting.fr/media/catalog/product/";

export const buildProductImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return path.startsWith("/")
    ? `${MEDIA_BASE_URL}${path.slice(1)}`
    : `${MEDIA_BASE_URL}${path}`;
};

export const getProductImageUrl = (product) => {
  if (!product) return null;

  if (product.image) {
    const url = buildProductImageUrl(product.image);
    if (url) return url;
  }

  if (
    Array.isArray(product.media_gallery_entries) &&
    product.media_gallery_entries.length > 0
  ) {
    const galleryUrl = buildProductImageUrl(
      product.media_gallery_entries[0].file
    );
    if (galleryUrl) return galleryUrl;
  }

  if (Array.isArray(product.custom_attributes)) {
    const imageAttr = product.custom_attributes.find((attr) =>
      ["image", "small_image", "thumbnail"].includes(attr?.attribute_code)
    );
    const url = buildProductImageUrl(imageAttr?.value);
    if (url) return url;

    const firstAttrUrl = buildProductImageUrl(
      product.custom_attributes[0]?.value
    );
    if (firstAttrUrl) return firstAttrUrl;
  }

  if (product.product && product.product !== product) {
    return getProductImageUrl(product.product);
  }

  return null;
};

export const getFallbackImageUrl = () =>
  "https://via.placeholder.com/120x120?text=Image";

